export { default } from '@triptyk/ember-utils/utils/file-to-form-data';
